import React, { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BookingProvider } from "./data";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import Gallery from "./components/Gallery";
import Amenities from "./components/Amenities";
import Experiences from "./components/Experiences";
import Availability from "./components/Availability";
import Location from "./components/Location";
import Policies from "./components/Policies";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import WhatsAppFloat from "./components/WhatsAppFloat";
import "./App.css";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
        raf = requestAnimationFrame(loop);
        return () => { cancelAnimationFrame(raf); lenis.destroy(); window.__lenis = null; };
    }, []);

    return (
        <BookingProvider>
            <div className="min-h-screen bg-[#FAF8F5]">
                <Navbar />
                <main>
                    <Hero />
                    <Overview />
                    <Gallery />
                    <Amenities />
                    <Experiences />
                    <Availability />
                    <Location />
                    <Policies />
                    <Contact />
                </main>
                <Footer />
                <BookingModal />
                <WhatsAppFloat />
                <Toaster position="top-center" richColors />
            </div>
        </BookingProvider>
    );
}

export default App;
